import type { RegistryproviderAssetCategoriesData } from '@polaris/api-client'
import Image from 'next/image'
import { Skeleton } from '../ui/skeleton'

interface TrendingCategoryBadgeProps {
  category?: RegistryproviderAssetCategoriesData
  isLoading?: boolean
}

export function TrendingCategoryBadge({
  category,
  isLoading = false,
}: TrendingCategoryBadgeProps) {
  if (isLoading) {
    return (
      <div className='flext items-center'>
        <Skeleton className='w-34 h-16 rounded-2xl' />
      </div>
    )
  }

  return (
    <div className='flex flex-row items-center justify-center gap-3 px-4 py-2 rounded-2xl border-1 border-border1 min-w-44 min-h-16'>
      <div className='flex flex-row items-center'>
        {category?.assets_image.slice(0, 3).map((asset, ind) => (
          <Image
            key={asset}
            src={asset}
            alt={`${category?.name} token icon ${ind}`}
            width={32}
            height={32}
            className='rounded-full -mr-3 last:mr-0'
            unoptimized
          />
        ))}
      </div>
      <div className='flex flex-col items-start justify-center'>
        <span className='text-sm text-secondary'>Current Trend</span>
        <span className='text-sm text-primary font-semibold'>
          {category?.name}
        </span>
      </div>
    </div>
  )
}
